import { enums, nullable, number, object, string } from "superstruct";

import {
    BRANDING_FONT_COLOR,
    BRANDING_LAUNCHER_ICON,
    BRANDING_LAUNCHER_POSITION,
    BRANDING_LAUNCHER_STYLE,
    BRANDING_LAUNCHER_VISIBILITY,
    BRANDING_POPUP_VIEW,
    BRANDING_THEME_COLOR,
    BRANDING_WIDGET_TYPES,
} from "../constants";

const RewardsBrandingLauncherPositionSchema = object({
    side: number(),
    bottom: number(),
});

const RewardsStorefrontValuesBrandingThemeColorSchema = enums([
    BRANDING_THEME_COLOR.primaryColor,
    BRANDING_THEME_COLOR.secondaryColor,
]);

const RewardsStorefrontValuesBrandingFontColorSchema = enums([
    BRANDING_FONT_COLOR.white,
    BRANDING_FONT_COLOR.black,
]);

const RewardsStorefrontValuesBrandingSchema = object({
    general: object({
        theme: object({
            primaryColor: string(),
            secondaryColor: string(),
        }),
        buttons: object({
            themeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
            fontColor: RewardsStorefrontValuesBrandingFontColorSchema,
        }),
        content: object({
            iconsThemeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
            linksThemeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
        }),
        widget: object({
            type: enums([
                BRANDING_WIDGET_TYPES.popUpWidget,
                BRANDING_WIDGET_TYPES.drawerWidget,
            ]),
        }),
    }),
    popUpWidget: object({
        launcher: object({
            appearance: object({
                themeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
                fontColor: RewardsStorefrontValuesBrandingFontColorSchema,
                style: enums([
                    BRANDING_LAUNCHER_STYLE.iconWithText,
                    BRANDING_LAUNCHER_STYLE.textOnly,
                    BRANDING_LAUNCHER_STYLE.iconOnly,
                ]),
            }),
            icon: object({
                type: enums([
                    BRANDING_LAUNCHER_ICON.default,
                    BRANDING_LAUNCHER_ICON.gift,
                    BRANDING_LAUNCHER_ICON.ticket,
                    BRANDING_LAUNCHER_ICON.star,
                    BRANDING_LAUNCHER_ICON.ribbon,
                ]),
                color: RewardsStorefrontValuesBrandingFontColorSchema,
                customUrl: nullable(string()),
            }),
            position: object({
                placement: enums([
                    BRANDING_LAUNCHER_POSITION.bottomRight,
                    BRANDING_LAUNCHER_POSITION.bottomLeft,
                ]),
                desktop: RewardsBrandingLauncherPositionSchema,
                mobile: RewardsBrandingLauncherPositionSchema,
            }),
            visibility: object({
                device: enums([
                    BRANDING_LAUNCHER_VISIBILITY.allDevices,
                    BRANDING_LAUNCHER_VISIBILITY.desktopOnly,
                    BRANDING_LAUNCHER_VISIBILITY.hide,
                ]),
            }),
        }),
        popUpContent: object({
            banner: object({
                themeColor: RewardsStorefrontValuesBrandingThemeColorSchema,
                fontColor: RewardsStorefrontValuesBrandingFontColorSchema,
                programName: string(),
                image: nullable(string()),
            }),
            view: enums([
                BRANDING_POPUP_VIEW.home,
                BRANDING_POPUP_VIEW.waysToEarnPoints,
                BRANDING_POPUP_VIEW.waysToSpendPoints,
                BRANDING_POPUP_VIEW.vipTiers,
            ]),
        }),
    }),
});

export default RewardsStorefrontValuesBrandingSchema;
